import React from 'react';
import { ControllerProvider, useController } from './controller-context';
import { HostProvider, useHost } from './host-context';
export function FormViewerContext(_ref) {
  let {
    children,
    host,
    wfActions,
    wfConfig,
    wfResults
  } = _ref;
  return /*#__PURE__*/React.createElement(HostProvider, {
    host: host
  }, /*#__PURE__*/React.createElement(ControllerProvider, {
    wfActions: wfActions,
    wfConfig: wfConfig,
    wfResults: wfResults
  }, children));
}
export function useFormViewerContext() {
  const controller = useController();
  const host = useHost();
  return {
    controller,
    host
  };
}
//# sourceMappingURL=form-viewer-context.js.map